import { render, staticRenderFns } from "./cardComponent.vue?vue&type=template&id=06171d53&"
import script from "./cardComponent.vue?vue&type=script&lang=js&"
export * from "./cardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports